import { type FaqItem } from '../types';
import { APP_NAME } from '@glow/shared/lib/constants';

export const masterFaqItems: FaqItem[] = [
  {
    question: 'Как быстро я найду первых клиентов?',
    answer: `
      Первые клиенты появятся, когда вы зарегистрируетесь и заполните
      профиль. Следуйте рекомендациям и пошаговым инструкциям
    `,
  },
  {
    question: 'От чего зависит количество клиентов?',
    answer: `От вашего местоположения, цены, свободных окон и профиля.`,
  },
  {
    question: 'Как клиенту записаться на процедуру?',
    answer: `
      Найти профиль мастера в ${APP_NAME}, указать процедуру и выбрать удобное
      время.
    `,
  },
  {
    question: 'Почему клиент записывается сразу без моего подтверждения?',
    answer: `
      Для клиента важно получить услугу и быть уверенным, что он ее получит.
      Не опоздает на важное мероприятие В первую очередь мы нацелены на
      удобства для конечного потребителя. Это выгодно всем. Если им будет
      удобно пользоваться сервисом, то у вас будет постоянный приток новых
      клиентов.
    `,
  },
  {
    question: 'Могу ли я отменить запись клиента?',
    answer: `
      Вы можете отменить или перенести запись, но это будет сказываться на
      вашем рейтинге и отзывах. Клиент будет вправе написать честный отзыв.
    `,
  },
  {
    question: 'Как работает рейтинговая система?',
    answer: `
      Чем выше рейтинг, тем больше доверия к мастеру. А значит, его увидит
      большее число клиентов. Рейтинг начисляется за оформление профиля,
      выполненные работы и положительные отзывы
    `,
  },
  {
    question: 'Смогу ли я оспаривать негативные отзывы?',
    answer: `
      Да. Если клиент намеренно создал прецедент для того, чтобы испортить
      вашу репутацию - по вашему обращению мы проведем проверку и
      восстановим справедливость
    `,
  },
  {
    question:
      'Может ли клиент записаться на одно время сразу к нескольким мастерам?',
    answer: `
      У клентов нет возможности записываться на одну и ту же услугу к разным
      специалистам в рамках маленького периода времени. Таким образом мы
      исключаем случаи, когда клиенты впустую занимают окна своих мастеров,
      параллельно записываясь сразу к нескольким
    `,
  },
  {
    question: 'За что я могу получить блокировку?',
    answer: `Нарушение правил сервиса, с которыми можете ознакомиться здесь`,
  },
  {
    question: 'Почему нам стоить доверять?',
    answer: `
      - Работаем надежно. Ежедневно записываем на услуги более 12 000
        клиентов
      <br />
      - Нам доверяют такие-то бренды
    `,
  },
];
